// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"rM-z","carouselContainer":"sM-z"};